export default __webpack_public_path__ + "static/media/solution_80.c05edb87.png";